<span class="form-input-number">
  <label [htmlFor]="id" [innerHTML]="label ? label : ('field.'+ field) | translate" class="input-label" [hidden]="noLabel"></label>
  <p-inputnumber [id]="id" inputId="integeronly" [(ngModel)]="formControl['value']" (ngModelChange)="onInput($event)"
    [disabled]="formControl['disabled'] || disabled" 
    [ngClass]="{ 'disabled': formControl['disabled'] || disabled }"
    [mode]="'decimal'" [minFractionDigits]="decimals" [maxFractionDigits]="decimals"
    [locale]="'es-ES'" [useGrouping]="false" />
  <app-form-input-error [show]="formControl.invalid && (formControl.dirty || formControl.touched)"
    [required]="formControl.errors?.['required']"
    [max]="formControl.errors?.['max']"
    [min]="formControl.errors?.['min']"></app-form-input-error>
  <small class="info" [innerHtml]="info" *ngIf="info"></small>
</span>
